/* eslint-disable jira/filename-case */

import '@jira/platform__vendor/src/vendor-parcel.tsx';
import '@jira/platform__vendor/src/commons-parcel.tsx';
import { provideHealthcheck } from '@jira/platform__healthcheck/src/utils/healthcheck-utils/index.tsx';
import global from './global.tsx';

global.install();
provideHealthcheck();
